import { SelectionOptions } from 'coreOld/enums';
import { PartNumberHelper } from 'partsOld/helpers';
import { ICompanyPart, ICompanyPartForm, IPart } from 'partsOld/types';

export const mapCompanyPartToPartInfo = (part: Partial<ICompanyPart>): Partial<IPart> => {
  return {
    descriptionLong: part?.descriptionLong,
    manufacturerName: part?.manufacturerName,
    number: part?.part,
  };
};

export const mapCompanyPartToPartForm = (part: Partial<ICompanyPart>): ICompanyPartForm => {
  if (!part) {
    return;
  }

  return {
    className: part.className,
    companyPartStatus: part.companyPartStatus,
    externalUom: part.externalUom,
    manufacturerId: part.manufacturerId,
    manufacturerOrderIncrement: part.manufacturerOrderIncrement,
    manufacturerName: part.manufacturerName,
    vendorNumber: part.vendorNumber,
    companyManufacturerName: part.companyManufacturerName,
    companyManufacturerId: part.companyManufacturerId,
    mfgPartStatus: part.mfgPartStatus,
    minimumQuantity: part.minimumQuantity,
    orderIncrement: part.orderIncrement,
    packageType: part.packageType,
    packageUom: part.packageUom,
    part: PartNumberHelper.toLabel(part.part),
    partBaseCode: part.partBaseCode,
    pkgUnits: part.pkgUnits,
    pricingGroup1: part.pricingGroup1,
    pricingGroup2: part.pricingGroup2,
    pricingGroup3: part.pricingGroup3,
    pricingGroup4: part.pricingGroup4,
    pricingGroup5: part.pricingGroup5,
    pricingGroupDescription1: part.pricingGroupDescription1,
    pricingGroupDescription2: part.pricingGroupDescription2,
    pricingGroupDescription3: part.pricingGroupDescription3,
    pricingGroupDescription4: part.pricingGroupDescription4,
    pricingGroupDescription5: part.pricingGroupDescription5,
    quotePriceDecimals: part.quotePriceDecimals,
    bomPriceDecimals: part.bomPriceDecimals,
    replacementPart: part.replacementPart,
    salesUom: part.salesUom,
    taaStatus: part.taaStatus,
    uomId: part.uomId || null,
    uom: part.uom,
    id: part.id,
  };
};

export const mapCompanyPartToServer = (data: Partial<ICompanyPart>) => {
  if (!data) {
    return;
  }

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const { manufacturerName, ...rest } = mapCompanyPartToPartForm(data);

  return {
    ...rest,
  };
};

export const mapRemoveCompanyPartsToServer = (
  parts: IPart[],
  selectionMode?: SelectionOptions,
  filters?: Record<string, any>
) => {
  if (selectionMode === SelectionOptions.FILTERED) {
    return {
      filtered: 1,
      filters,
    };
  }

  return {
    ids: parts.map((part) => part.id),
  };
};
